import {
  AttendanceExportContext,
  buildStudentAttendanceExportPayload as buildPayload,
} from './attendanceExportBuilder'
import {AttendanceVisualReportHeader} from './attendanceReportExportTypes'
import {AttendanceStudentReport} from './attendanceWizardTypes'
import {buildAttendanceVisualSummary} from './buildAttendanceVisualSummary'
import {AttendanceParsedContent} from './parseAttendanceAnswer'

export function reportToExportContext(
  report: Pick<
    AttendanceStudentReport,
    | 'studentId'
    | 'studentName'
    | 'class'
    | 'section'
    | 'branch'
    | 'startDate'
    | 'endDate'
    | 'attendanceMode'
  >,
  attendanceModeLabel?: string
): AttendanceExportContext {
  return {
    studentId: report.studentId,
    studentName: report.studentName,
    branch: report.branch,
    className: report.class,
    section: report.section,
    startDate: report.startDate,
    endDate: report.endDate,
    attendanceModeLabel,
  }
}

export function headerToExportContext(
  header: AttendanceVisualReportHeader | undefined,
  studentId?: string,
  attendanceModeLabel?: string
): AttendanceExportContext {
  return {
    studentId,
    studentName: header?.studentName,
    branch: header?.branch,
    className: header?.className,
    section: header?.section,
    startDate: header?.startDate,
    endDate: header?.endDate,
    attendanceModeLabel,
  }
}

export function buildStudentReportExportPayload(
  report: AttendanceStudentReport,
  attendanceModeLabel?: string
): ReturnType<typeof buildPayload> {
  const ctx = reportToExportContext(report, attendanceModeLabel)
  const summary = buildAttendanceVisualSummary(report.parsed)
  const base = report.studentName?.trim().replace(/\s+/g, '-') || `attendance-${report.studentId}`

  return buildPayload({
    title: report.studentName?.trim() || 'Attendance report',
    filename: base,
    ctx,
    content: report.parsed,
    summary,
    attendanceMode: report.attendanceMode,
  })
}

export function buildVisualReportExportPayload(options: {
  header?: AttendanceVisualReportHeader
  studentId?: string
  content: AttendanceParsedContent
  exportFilenameBase: string
  defaultTitle: string
  attendanceModeLabel?: string
}): ReturnType<typeof buildPayload> {
  const {header, studentId, content, exportFilenameBase, defaultTitle, attendanceModeLabel} =
    options
  const ctx = headerToExportContext(header, studentId, attendanceModeLabel)
  const summary = buildAttendanceVisualSummary(content)
  const base = header?.studentName?.trim().replace(/\s+/g, '-') || exportFilenameBase

  return buildPayload({
    title: header?.studentName?.trim() || defaultTitle,
    filename: base,
    ctx,
    content,
    summary,
    attendanceMode: header?.attendanceMode,
  })
}
